var inRange = function (a, b, range) {
    var r = range < 0 ? 0 : range;
    return Math.abs(a - b) <= r;
};
export var isLessThanInRange = function (a, b, range) {
    return a < b && !inRange(a, b, range);
};
//# sourceMappingURL=comparison.js.map